import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const redirectTargetSlice = createSlice({
  name: 'redirectTargetSlice',
  initialState: { target: undefined } as { target?: string },
  reducers: {
    setRedirectTarget: (state, action: PayloadAction<string>) => {
      state.target = action.payload;
    },
  },
});

export const { setRedirectTarget } = redirectTargetSlice.actions;
